import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import FlightSearchResult from 'components/FlightSearchResult/FlightSearchResult';

import { FlightSearchResults_results$key } from '__generated__/FlightSearchResults_results.graphql';
import Alert from '@mui/material/Alert';

type Props = {
  id: string;
  onAdd: () => void;
  results: FlightSearchResults_results$key;
};

const FlightSearchResults: FC<Props> = props => {
  const { id, onAdd } = props;

  const { flights } = useFragment(
    graphql`
      fragment FlightSearchResults_results on FlightSearchResult {
        flights {
          priceKey
          ...FlightSearchResult_flight
        }
      }
    `,
    props.results
  );

  return (
    <Box sx={{ mt: 2 }}>
      <Divider sx={{ mt: 4, mb: 2 }} />

      {flights.length > 0 ? (
        flights.map(flight => (
          <FlightSearchResult
            id={id}
            flight={flight}
            key={flight.priceKey}
            onAdd={onAdd}
          />
        ))
      ) : (
        <Alert severity="warning">
          Pagal pasirinktus kriterijus skrydžių nerasta
        </Alert>
      )}
    </Box>
  );
};

export default FlightSearchResults;
